import { IHeavyDutyMachinerySearchFilters } from '../interfaces/heavyDutyMachinery/ISearch';

// Every array-valued category /heavy-duty-machinery's search can filter/facet on --
// shared between the page (which owns filter state) and FiltersModal (which
// renders + toggles it), so both agree on exactly which keys are "facets".
export type FacetCategory = keyof Pick<
  IHeavyDutyMachinerySearchFilters,
  | 'category'
  | 'accessType'
>;

export const toggleValue = (values: string[] | undefined, value: string): string[] | undefined => {
  const current = values ?? [];
  const next = current.includes(value) ? current.filter((v) => v !== value) : [...current, value];
  return next.length > 0 ? next : undefined;
};
